<template>
  <div id="home">
    <div class="wechat_log" v-show="weShow">
      <div class="wechat_box">
        <img src="../assets/xcx_icon.png" alt="" />
        <p>小程序</p>
      </div>
      <!-- <div class="wechat_box">
        <img src="../assets/app_icon.png" alt="" />
        <p>APP客户端</p>
      </div> -->
    </div>
    <el-container>
      <el-header>
        <div class="container">
          <div class="index_navbar">
            <div class="logo" @click="goIndex">
              <img src="../assets/logo_nav.png" alt="" />
            </div>
            <div
              class="kcfl"
              @mouseenter="changeKcfl(true)"
              @mouseleave="changeKcfl(false)"
            >
              <img
                class="courseListImg"
                src="../../src/assets/courseList.png"
                alt=""
              />
              课程分类
              <el-cascader-panel
                :class="[treeList.length < 10 ? 'treePanel' : 'treePanels']"
                v-show="kcfl"
                :options="treeList"
                :props="props"
                @change="handleChange"
              >
                <template slot-scope="el">
                  <span @click="handleNodeClick(el)">{{ el.data.name }}</span>
                </template>
              </el-cascader-panel>
            </div>
            <div class="sousuo">
              <el-input
                placeholder="请输入内容"
                v-model="search"
                class="input-with-select"
                @keyup.enter.native="searchEnter"
              >
                <el-select v-model="select" slot="prepend" placeholder="请选择">
                  <el-option label="课程" value="course"></el-option>
                  <el-option label="学院" value="college"></el-option>
                  <el-option label="讲师" value="teacher"></el-option>
                  <!-- <el-option label="证书" value="certificate"></el-option> -->
                </el-select>
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchMain"
                ></el-button>
              </el-input>
            </div>
            <div class="fenge">
              <span
                style="margin-right: 20px;margin-top: 3px"
                @click="gotoshopcar"
                ><img src="../assets/shop_car.png" alt=""
              /></span>
              <span
                style="margin-right: 20px; margin-top: 3px"
                @mouseenter="weShow = true"
                @mouseleave="weShow = false"
                ><img src="../assets/meua_car.png" alt=""
              /></span>
              <el-divider direction="vertical"></el-divider>
              <div style="margin-right: 20px" @click="goStudyCenter">
                学习中心
              </div>
              <div style="margin-right: 20px" @click="goindexpage">
                证书服务
              </div>
              <span @click="goSz">入驻/合作</span>
              <el-divider direction="vertical"></el-divider>
            </div>
            <div class="nosigne" v-if="this.token == '' || this.token == null">
              <div class="loging" @click="loginNew">登录</div>
              <div class="line">/</div>
              <div class="register" @click="loginNew">
                注册
              </div>
            </div>
            <div class="signedin" v-if="this.token != '' && this.token != null">
              <div class="head_portrait">
                <el-avatar :size="40" :src="this.headPic"></el-avatar>
              </div>
              <div class="pc_name">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{ this.nickName
                    }}<i class="el-icon-caret-bottom el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="b">我的订单</el-dropdown-item>
                    <!-- <el-dropdown-item command="c">发票管理</el-dropdown-item> -->
                    <el-dropdown-item command="d">账号设置</el-dropdown-item>
                    <el-dropdown-item command="help">帮助手册</el-dropdown-item>
                    <el-dropdown-item command="e">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </el-header>
      <el-main class="mainbody"> <router-view></router-view></el-main>
    </el-container>
  </div>
</template>

<script>
import { treeList, baseinfo } from "@/api/api.js";
import { getCookie, setCookie, removeCookie } from "@/utils/cookies";
import Cookies from "js-cookie";
export default {
  name: "Home",
  data() {
    return {
      weShow: false,
      codeShow: false,
      token: getCookie("myToken"),
      headPic: "",
      nickName: "",
      search: "",
      select: "course",
      treeList: [],
      kcfl: false,
      activeName: "first",
      props: {
        expandTrigger: "hover",
        value: "productCategoryId",
        label: "name",
        children: "children",
        expandTrigger: "hover"
        // checkStrictly :true
      }
    };
  },

  created() {
    if (this.token != null) {
      baseinfo({}).then(res => {
        if (res.msg == "success") {
          this.headPic = res.data.headPic;
          this.nickName = res.data.nickName;
          setCookie("headPic", res.data.headPic); //头像
          setCookie("nickName", res.data.nickName);
          setCookie("imUserName", res.data.imUserName); //im账号
          setCookie("imSecret", res.data.imSecret); //im密码
          setCookie("userId", res.data.userId);
        } else if (res.msg == "登录过期，请重新登录！") {
          Cookies.remove("phone", {
            domain: process.env.NODE_ENV == "development" ? "" : ".i-ronge.com"
          });
          Cookies.remove("account", {
            domain: process.env.NODE_ENV == "development" ? "" : ".i-ronge.com"
          });
          Cookies.remove("password", {
            domain: process.env.NODE_ENV == "development" ? "" : ".i-ronge.com"
          });
          removeCookie("myToken");
          removeCookie("headPic");
          removeCookie("nickName");
          removeCookie("userName");
          removeCookie("sex");
          removeCookie("email");
          removeCookie("phone");
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    }

    //导航分类
    treeList({}).then(res => {
      if (res.msg == "success") {
        this.treeList = res.data;
      } else {
        this.$message({
          message: res.msg,
          type: "warning"
        });
      }
    });
  },
  methods: {
    loginNew() {
      let url = window.location.href;
      let index_url = window.location.host;
      setCookie("redirectUrl", url);
      if (index_url === "test.i-ronge.com") {
        window.location.href = "https://login-center-test.i-ronge.com";
      } else if (
        index_url === "saas.i-ronge.com" ||
        index_url === "vocation.i-ronge.com"
      ) {
        window.location.href = "https://login-center.i-ronge.com";
      }
    },
    handleNodeClick(el) {
      let text = this.$router.resolve({
        path: `/curriculum`,
        query: {
          productCategoryId: el.node.path[2],
          isFree: 0,
          productCategoryId1: el.node.path[0],
          productCategoryId2: el.node.path[1]
        }
      });
      window.open(text.href, "_blank");
    },
    changeKcfl(val) {
      this.kcfl = val;
    },
    //进入企业大学
    goindexpage() {
      this.$router.push("/certificateStore");
    },
    //进入学习中心
    goStudyCenter() {
      if (this.token == null || this.token == "") {
        let url = window.location.href;
        let index_url = window.location.host;
        setCookie("redirectUrl", url);
        if (index_url === "test.i-ronge.com") {
          window.location.href = "https://login-center-test.i-ronge.com";
        } else if (
          index_url === "saas.i-ronge.com" ||
          index_url === "vocation.i-ronge.com"
        ) {
          window.location.href = "https://login-center.i-ronge.com";
        }
      } else {
        this.$router.push("/personal");
        this.$root.eventHub.$emit("rooter", "123");
      }
    },
    goIndex() {
      this.$router.push("/index");
    },
    //用户个人中心选项
    async handleCommand(command) {
      if (command == "a") {
      }
      if (command == "b") {
        this.$router.push("/order");
      }
      if (command == "c") {
        this.$router.push("/invoice");
      }
      if (command == "d") {
        this.$router.push("/settings");
      }
      if (command == "e") {
        Cookies.remove("phone", {
          domain: process.env.NODE_ENV == "development" ? "" : ".i-ronge.com"
        });
        Cookies.remove("account", {
          domain: process.env.NODE_ENV == "development" ? "" : ".i-ronge.com"
        });
        Cookies.remove("password", {
          domain: process.env.NODE_ENV == "development" ? "" : ".i-ronge.com"
        });
        removeCookie("myToken"); //token
        removeCookie("headPic");
        removeCookie("nickName");
        removeCookie("userName");
        removeCookie("sex");
        removeCookie("email");
        removeCookie("phone");
        this.$message({
          message: "退出登陆成功",
          type: "success"
        });
        setTimeout(function() {
          window.location.reload();
        }, 1000);
      }
      if (command == "help") {
        let src =
          "https://statics-saas.i-ronge.com/frontend/help-book/%E8%9E%8De%E5%AD%A6%C2%B7%E6%98%8E%E8%81%8C%E9%81%93%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%EF%BC%88PC%E7%AB%AF%EF%BC%89.pdf";
        const response = await fetch(src);
        const blob = await response.blob();
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "帮助手册";
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    gotoshopcar() {
      if (this.token == null || this.token == "") {
        let url = window.location.href;
        let index_url = window.location.host;
        setCookie("redirectUrl", url);
        if (index_url === "test.i-ronge.com") {
          window.location.href = "https://login-center-test.i-ronge.com";
        } else if (
          index_url === "saas.i-ronge.com" ||
          index_url === "vocation.i-ronge.com"
        ) {
          window.location.href = "https://login-center.i-ronge.com";
        }
      } else {
        this.$router.push("/shopcar");
      }
    },
    searchMain() {
      if (this.select == "course") {
        const { href } = this.$router.resolve({
          path: "/searchCourse",
          query: {
            keyWord: this.search
          }
        });
        window.open(href, "_blank");
      }
      if (this.select == "college") {
        const { href } = this.$router.resolve({
          path: "/searchCollege",
          query: {
            keyWord: this.search
          }
        });
        window.open(href, "_blank");
      }
      if (this.select == "teacher") {
        const { href } = this.$router.resolve({
          path: "/searchTeacher",
          query: {
            keyWord: this.search
          }
        });
        window.open(href, "_blank");
      }
      if (this.select == "certificate") {
        const { href } = this.$router.resolve({
          path: "/searchCertificate",
          query: {
            keyWord: this.search
          }
        });
        window.open(href, "_blank");
      }
    },
    searchEnter() {
      if (this.select == "course") {
        const { href } = this.$router.resolve({
          path: "/searchCourse",
          query: {
            keyWord: this.search
          }
        });
        window.open(href, "_blank");
      }
      if (this.select == "college") {
        const { href } = this.$router.resolve({
          path: "/searchCollege",
          query: {
            keyWord: this.search
          }
        });
        window.open(href, "_blank");
      }
      if (this.select == "teacher") {
        const { href } = this.$router.resolve({
          path: "/searchTeacher",
          query: {
            keyWord: this.search
          }
        });
        window.open(href, "_blank");
      }
      if (this.select == "certificate") {
        const { href } = this.$router.resolve({
          path: "/searchCertificate",
          query: {
            keyWord: this.search
          }
        });
        window.open(href, "_blank");
      }
    },
    goSz() {
      const Url = window.location.host;
      if (Url === "test.i-ronge.com") {
        //测试网址
        window.location.href = "https://supply-admin-test.i-ronge.com";
      } else if (Url === "saas.i-ronge.com") {
        // 默认正式
        window.location.href = "https://supply-admin.i-ronge.com";
      } else if (Url === "vocation.i-ronge.com") {
        // 默认正式
        window.location.href = "https://master.i-ronge.com";
      }
    },

    handleChange(val) {
      console.log(val);
      let text = this.$router.resolve({
        path: `/curriculum`,
        query: {
          productCategoryId: val[2],
          isFree: 0,
          productCategoryId1: val[0],
          productCategoryId2: val[1]
        }
      });
      window.open(text.href, "_blank");
    },
    goPrivacy() {
      this.centerDialogVisible = false;
      this.$router.push({ path: "/privacy" });
    },
    useAgreement() {
      this.centerDialogVisible = false;
      this.$router.push({ path: "/useAgreement" });
    }
  }
};
</script>

<style scoped>
#home {
  height: 100%;
}
#home >>> .el-container {
  height: 100%;
}
.mainbody {
  height: 100%;
  background: #f5f7fa;
}
.el-main {
  padding: 0;
}
.el-header {
  height: 70px !important;
  border-bottom: solid 1px #e6e6e6;
}
.index_navbar {
  display: flex;
  width: 100%;
  height: 68px;
  line-height: 68px;
}
.logo {
  cursor: pointer;
  width: 60px;
  height: 60px;
  margin: auto 0;
}
.logo img {
  max-width: 100%;
}
.head_portrait {
  width: 50px;
  margin-top: 14px;
  margin-left: 10px;
  cursor: pointer;
}
.pc_name {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  margin-left: 5px;
  cursor: pointer;
}
.signedin {
  display: flex;
}
.el-popper[x-placement^="bottom"] {
  margin-top: -10px;
}
.line {
  margin: 0 5px;
}
.loging,
.register {
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #ff7b33;
  cursor: pointer;
}
.nosigne {
  border-radius: 15px;
  margin-left: 50px;
  display: flex;
  color: #ff7b33;
}
.kcfl {
  background-color: #fff;
  z-index: 2000;
  position: relative;
}
.kcfl >>> .el-cascader-panel {
  font-size: 14px;
  color: #333333;
  position: absolute;
  top: 60px;
  left: 30px;
  background-color: #fff;
  height: 371px;
}
.kcfl >>> .el-scrollbar {
  overflow-y: scroll;
  overflow-x: hidden;
}
.treePanel {
  height: auto;
}
.treePanel >>> .el-cascader-menu__wrap {
  height: auto;
}
.treePanels {
  height: 370px;
}
.treePanels >>> .el-cascader-menu__wrap {
  height: 376px;
}
.sousuo {
  margin-left: 30px;
}
.sousuo >>> .el-input-group {
  border-radius: 4px;
  border: 1px solid #ff7b33;
}
.sousuo >>> .el-input-group__append {
  background-color: #ff7b33;
  border: 0;
  color: #fff;
}
.sousuo >>> .el-input-group__prepend {
  background-color: #fff;
  border: 0;
}
.sousuo >>> .el-select {
  width: 75px;
  border: 0;
}
.sousuo >>> .el-input__inner {
  border: 0;
}
.el-select-dropdown__item.selected {
  color: #ff7b33;
  font-weight: 400;
}
.el-dropdown-menu__item:hover {
  color: #ff7b33;
}
.fenge {
  display: flex;
  margin-left: 100px;
  font-size: 16px;
}
.fenge span {
  display: block;
  cursor: pointer;
}
.fenge span:hover {
  color: #ff7b33;
}
.fenge div:hover {
  color: #ff7b33;
}
.fenge div {
  cursor: pointer;
}
.fenge span img {
  width: 16px;
  height: 16px;
}
.fenge >>> .el-divider--vertical {
  margin: 26px 12px;
}
#home >>> .el-dialog {
  border-radius: 8px;
}
.login-box >>> .el-tabs__item {
  width: 215px;
  padding: 0;
  height: 60px;
  display: inline-block;
  list-style: none;
  font-size: 24px;
  text-align: center;
  font-weight: 700;
  color: #303133;
  position: relative;
}
.login-box >>> .el-input__inner {
  background-color: #fff;
  background-image: none;
  border-radius: 0px;
  border: 0;
  border-bottom: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  width: 100%;
}
.login-box >>> .el-tabs__active-bar {
  height: 4px;
  background-color: #ff7b33;
}
.phone_name {
  margin-top: 60px;
}
.password {
  margin-top: 30px;
}
.code_yzm {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.passcode {
  width: 250px;
}
.yzm {
  width: 140px;
  line-height: 40px;
  line-height: 40px;
  background: #c9c9c9;
  border-radius: 21px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.box_warp {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 14px;
  color: #ff7b33;
}
.box_warp div {
  cursor: pointer;
}
.login {
  height: 42px;
  text-align: center;
  line-height: 42px;
  background: #ff7b33;
  border-radius: 21px;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  margin-top: 28px;
}
.el-divider__text {
  color: #909399;
}
.wechatqq {
  width: 100px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.wechatqq div {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.wechatqq div img {
  max-width: 100%;
}
.main_center {
  width: 430px;
  height: 430px;
}
.main_center >>> .el-tabs__item {
  width: 215px;
  padding: 0;
  height: 60px;
  display: inline-block;
  list-style: none;
  font-size: 24px;
  text-align: center;
  font-weight: 700;
  color: #303133;
  position: relative;
}
.main_center >>> .el-input__inner {
  background-color: #fff;
  background-image: none;
  border-radius: 0px;
  border: 0;
  border-bottom: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  width: 100%;
}
.phone_name {
  margin-top: 60px;
}
.password {
  margin-top: 30px;
}
.code_yzm {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.passcode {
  width: 250px;
}
.yzm {
  width: 140px;
  line-height: 40px;
  line-height: 40px;
  background: #c9c9c9;
  border-radius: 21px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.other {
  width: 250px;
  margin: 30px auto 0;
}
.el-divider__text {
  color: #909399;
}
.wechatqq {
  width: 100px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.wechatqq div {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.wechatqq div img {
  max-width: 100%;
}

.main_center .tip {
  width: 112px;
  height: 14px;
  margin: 15px auto;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #ff7b33;
  cursor: pointer;
}
.title {
  width: 70px;
  height: 24px;
  margin: 0 auto;
  opacity: 1;
  font-size: 24px;
  font-weight: 700;
  text-align: left;
  color: #333333;
}
.main_center >>> .el-input-group__prepend {
  border: 0;
  border-bottom: 1px solid #dcdfe6;
  background-color: #fff;
  color: #333333;
}
.courseListImg {
  display: inline-block;
  width: 14px;
  height: 10px;
  margin: 30px 5px 0 40px;
}

.wechat_log {
  cursor: pointer;
  left: 49.5%;
  top: 8%;
  z-index: 99999;
  position: absolute;
  width: 170px;
  height: 192px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  padding: 30px;
}
.wechat_box {
  width: 110px;
  text-align: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #909399;
}
.wechat_box p {
  margin-top: 8px;
}
.wechat_log img {
  width: 110px;
  height: 110px;
}
.noLogin_tip {
  font-size: 14px;
  margin-top: 20px;
  text-align: center;
}
.other_tip {
  font-size: 14px;
  margin: 20px auto 0;
  display: flex;
  justify-content: space-between;
  width: 180px;
}
.other_tip span {
  cursor: pointer;
  color: #ff7b33;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue